import ReactDOM from 'react-dom/client';

import { TranslationHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';

import { App } from './app';
import { AppProvider } from './app.provider';
import { ApiConfig, BaseConfig, CookiesConfig, LoggerConfig, MaxElapsedEpochMsConfig } from './configs';
import { LoggerHelper } from './helpers';
import { localI18n } from './i18n';

const startupApp = () => {
	TranslationHelper.register(
		'localI18n',
		{
			default: { bcp: localI18n.pt, ab: {} },
			pt: { bcp: localI18n.pt, ab: {} },
			en: { bcp: localI18n.en, ab: {} },
		},
		{ addAndReplace: true }
	);

	LoggerHelper.init(LoggerConfig, {
		all: true,
		core: false,
		forms: false,
		formUtils: false,
		// inner modules
		app: true,
		blockStepManager: false,
		api: true,
	});

	LoggerHelper.log('App', 'Environment vars:', {
		env: process.env,
		BaseConfig,
		ApiConfig,
		LoggerConfig,
		CookiesConfig,
		MaxElapsedEpochMsConfig,
	});

	const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
	root.render(
		<AppProvider>
			<App />
		</AppProvider>
	);
};

// Call the startup function when the script runs
startupApp();

// Export the startup function for testing purposes
export { startupApp };
